import React from "react";

function scrollToTop(id) {
  if (!id) {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // This smooths the scrolling motion
    });
  } else {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
}

export default scrollToTop;
